import constants from "../constants/Feedback/validationAutomata";

const isValidMachine = (dot) => {
  let status = {
    startVertex: "",
    valid: false,
    validationError: 2,
    message: constants.validMachine.error.missState,
  };

  if (!dot || typeof dot !== "string") {
    return status;
  }

  try {
    const sections = dot.split(/\r?\n\r?\n/);
    const statesSection = sections[0] || "";
    const importantStatesSection = sections[2] || "";

    const states = statesSection
      .split(/\r?\n/)
      .map((s) => s.trim())
      .filter(Boolean);

    let importantStates = importantStatesSection
      .split(/\r?\n/)
      .map((s) => s.trim())
      .filter(Boolean);

    for (let i = 0; i < importantStates.length; i++) {
      let arrayTypeState = importantStates[i];

      const shapeMatch = arrayTypeState.match(
        /shape\s*=\s*["']?([A-Za-z0-9_]+)["']?/
      );
      const typeState = shapeMatch ? shapeMatch[1] : null;

      if (typeState == "Mdiamond" || typeState == "diamond") {
        const nameMatch = arrayTypeState.match(/^([^\s[]+)/);
        const name = nameMatch ? nameMatch[1].trim() : null;
        if (!name) {
          continue;
        }

        if (status.startVertex === "") {
          status.startVertex = name;
          status.valid = true;
          status.message = constants.validMachine.success.valid;
        } else {
          status.valid = false;
          status.validationError = 3;
          status.message = constants.validMachine.error.multiplesInitialStates;
          break;
        }
      }
    }

    if (status.startVertex === "") {
      status.valid = false;
      status.message = constants.validMachine.error.missInitialState;
    }

    if (states.length === 0) {
      status.validationError = 1;
      status.valid = false;
      status.message = constants.validMachine.error.missState;
    }

    return status;
  } catch (e) {
    console.error("isValidMachine parse error:", e);
    status.valid = false;
    status.message = constants.validMachine.error.missState;
    return status;
  }
};

export default { isValidMachine };
